import React from 'react';
import { FormInstance, Select, TimePicker } from 'antd';
import moment, { Moment } from 'moment-timezone';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';
import { OrganizationUnitShiftConfigFlatType } from '@scheduling/graphql';

export const TimeInput = ({
  disabled = false,
  shiftConfigs = [],
  form,
  onTimeSelect,
  startTime,
}: {
  disabled: boolean;
  shiftConfigs: OrganizationUnitShiftConfigFlatType[];
  form: FormInstance;
  onTimeSelect: (value: string) => void;
  startTime?: string;
}) => {
  const shiftStartDisabledTime = (currentDate: Moment) => {
    const selectedDate = form.getFieldValue('startDate');

    if (moment(selectedDate).startOf('day') > moment().startOf('day')) {
      return false;
    }

    return moment(currentDate) <= moment();
  };

  const options = shiftConfigs?.map((shiftConfig) => ({
    label: `${moment(shiftConfig.startTime).format('HH:mm')}`,
    value: moment(shiftConfig.startTime).format('HH:mm'),
  }));

  const onSelect = (value: Moment | null) => {
    const formattedValue = moment(value, 'HH:mm').format('HH:mm');

    onTimeSelect(formattedValue);
    form.setFieldsValue({
      startTime: formattedValue,
    });
  };

  if (shiftConfigs.length > 0) {
    return (
      <Select
        disabled={disabled}
        showSearch
        size="large"
        placeholder="Select time"
        getPopupContainer={(trigger) => trigger.parentNode}
        options={uniqBy(sortBy(options, 'value'), 'value')}
        onSelect={(value) => onSelect(moment(value, 'HH:mm'))}
        value={startTime}
      />
    );
  }

  return (
    <>
      <TimePicker
        name="startTime"
        format="HH:mm"
        size="large"
        showNow={false}
        disabled={disabled}
        disabledDate={shiftStartDisabledTime}
        minuteStep={15}
        hideDisabledOptions={true}
        value={startTime ? moment(startTime, 'HH:mm') : null}
        onSelect={(value) => onSelect(value)}
        onChange={(value) => onSelect(value)}
        popupClassName="noFooterTimePick"
      />
      <style jsx global>
        {`
          .noFooterTimePick .ant-picker-footer {
            display: none;
          }
        `}
      </style>
    </>
  );
};
